var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.101,
    cy: 11.334,
    r: 11.101,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.056 11.6h5.046m5.046 0h-5.046m0 0v4.781m0-4.78V6.289",
    stroke: "#fff",
    strokeWidth: 1.009
  })));
};
export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMyAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiByb2xlPSJwcmVzZW50YXRpb24iIGFyaWEtaGlkZGVuPSJ0cnVlIj4KPGNpcmNsZSBjeD0iMTEuMTAxNSIgY3k9IjExLjMzMzkiIHI9IjExLjEwMTUiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik02LjA1NTY2IDExLjYwMDhIMTEuMTAxOE0xNi4xNDc5IDExLjYwMDhIMTEuMTAxOE0xMS4xMDE4IDExLjYwMDhWMTYuMzgxM00xMS4xMDE4IDExLjYwMDhWNi4yODkwNiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjAwOTIzIi8+Cjwvc3ZnPgo=";